import React, { useState, useRef, useCallback, useEffect } from 'react';
import classNames from 'classnames';

import useObserver from '../../../hooks/useObserver';

import './StickyContainer.module.css';

const StickyContainer = ({
  children,
  className = null,
  rootMargin = '-80px',
  inline = false // disable stickyness
}) => {
  const contentRef = useRef();
  const [stuck, setStuck] = useState(false);

  const memoizedCallback = useCallback(nav => {
    if (!inline) {
      setStuck(!nav[0].isIntersecting);
    }
  }, []);
  const [attach, detach] = useObserver(memoizedCallback, {
    rootMargin
  });

  useEffect(() => {
    if (!inline) {
      attach(contentRef.current.parentElement);
      return () => {
        if (contentRef.current) {
          detach(contentRef.current.parentElement);
        }
      };
    }
  }, []);

  return (
    <div styleName="container">
      <div
        className={className}
        styleName={classNames('content', { stuck })}
        ref={contentRef}
      >
        {children}
      </div>
    </div>
  );
};

export default StickyContainer;
